
<template>
  <div class="color-swatches">
    <div class="l_swiper-button-prev" @click="l_slide('prev')"></div>

    <div class="large_swiper-container" >
        <div class='swiper-wrapper'>
            <div class='swiper-slide' v-for="(variant, index) in variants" :key="index">
              <div class="color" :style="{backgroundColor: variant.shades[0].hexaColor}" />
            </div>

            <span class="swiper--current" />
        </div>
    </div>

    <div class="l_swiper-button-next" @click="l_slide('next')"></div>
  </div>
</template>
<script>
import { Swiper } from 'swiper/js/swiper.esm.js'
import 'swiper/css/swiper.css'
import { TweenMax } from 'gsap'
// import _ from 'lodash'

export default {
  name: 'color-swatches',
  props: {
    variants: {
      type: Array,
      required: true
    },
    slidesPerView: {
      type: Number,
      default: 7
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    largeSwiper () {
      var largeSwiper = new Swiper('.large_swiper-container', {
        init: false,
        slidesPerView: this.slidesPerView,
        centeredSlides: true,
        slideToClickedSlide: true,
        spaceBetween: 20,
        simulateTouch: true,
        loop: false
      })
      largeSwiper.on('slideChange', ev => {
        this.l_selectColor()
        let nextButton = document.querySelector('.l_swiper-button-next')
        let prevButton = document.querySelector('.l_swiper-button-prev')
        largeSwiper.activeIndex >= largeSwiper.slides.length - 1
          ? (nextButton.style.opacity = '0')
          : (nextButton.style.opacity = '1')
        largeSwiper.activeIndex <= 0
          ? (prevButton.style.opacity = '0')
          : (prevButton.style.opacity = '1')
      })
      largeSwiper.on('slideChangeTransitionStart', ev => {
        this.l_slideStart(false)
      })
      largeSwiper.on('slideChangeTransitionEnd', ev => {
        this.l_slideEnd()
      })
      largeSwiper.on('touchStart', ev => {
        this.l_slideStart(true)
      })
      largeSwiper.on('touchEnd', ev => {
        this.l_slideEnd()
      })
      return largeSwiper
    }
  },
  methods: {
    l_slide (direction) {
      let currentSlide = this.largeSwiper.realIndex
      direction === 'prev'
        ? this.largeSwiper.slideToLoop(currentSlide - 1, 200, true)
        : this.largeSwiper.slideToLoop(currentSlide + 1, 200, true)
    },
    l_selectColor () {
      let index = this.largeSwiper.realIndex
      if (index >= 0 && index < this.variants.length) {
        this.$emit('selected', index)
      }
    },
    l_slideStart (touchStarted) {
      let colors = this.$el.querySelectorAll('.color')
      TweenMax.to(colors, 0.5, { scale: 0.85 })
      this.touchStarted = touchStarted
    },
    l_slideEnd () {
      // document.querySelector('.code').style.opacity = 0
      setTimeout(() => {
        let colors = this.$el.querySelectorAll('.color')
        TweenMax.to(colors, 0.5, { scale: 1 })
      }, 100)
    }
  },
  async mounted () {
    await this.largeSwiper.init()
    this.largeSwiper.slideTo(this.initialIndex)
    // this.$nextTick(() => {
    //   // this.currentColor = this.selectedColor
    //   this.l_slideToSelectedColor()
    // })
  }
}

</script>
<style lang='scss' scoped>
@import '../../style/css/screens.scss';
@keyframes l_selected-color-intro {
  0% {
    opacity: 0;
    transform: scale(0.8, 0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1.05, 1.05);
  }
}

.large_swiper-container {
  overflow: hidden;
  flex: 1;

  position: relative;
}

.color-swatches {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  .swiper-container {
    &.overscan {
      transform: scale(0.9);
    }
  }

  .l_swiper-button-prev,
  .l_swiper-button-next {
    flex: 0.2 1 0%;
    transition: all 0.4s ease;
    background-size: 44px;
    outline: none;
    top: 66px;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-position: center;
    background-repeat: no-repeat;
  }
  .l_swiper-button-prev {
    left: 30px;
    background-image: url('../../assets/arrow-left.png');
    &.overscan {
      left: 70px;
    }
  }
  .l_swiper-button-next {
    right: 30px;
    background-image: url('../../assets/arrow-left.png');
    transform: rotate(180deg);
    &.overscan {
      right: 70px;
    }
  }
  .color {
    width: 100%;
    height: 57px;

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      height: 35px;
    }
  }
  .l_selected-color {
    border: 1px solid #000;
    position: absolute;
    z-index: 1;
    left: 50%;
    pointer-events: none;
    width: 60px;
    height: 59px;
    margin-top: -58px;
    margin-left: -30px;
    animation: l_selected-color-intro 0.3s linear 1;
    animation-fill-mode: forwards;
  }

  .color-info {
    text-align: center;
    font-size: 16px;
    padding-top: 10px;
    .l_code {
      transition: all 0.4s ease;
      opacity: 0;
      font-weight: 800;
      margin-bottom: 2px;
    }
  }
}
</style>
